const percentageOf = (x, y, dec = 2) => {
  return Number((x/y)*100).toFixed(dec)
}

export default percentageOf